export default "__VITE_ASSET__CXytzqen__"